export enum DoBoxReplyPanelMode {
  OPTIONS = 'OPTIONS',
  CHAT = 'CHAT',
  REPLY = 'REPLY',
  SENT = 'SENT',
}
